<template>
  <ModalConfirmation
    hasBlur
    :showModal="showModal"
    title="Cancel Command"
  >
    <template v-slot:body>
      <ParagraphBody>
        Are you sure you want to cancel <b>{{ itemData.name }}?</b>
      </ParagraphBody>
      <ParagraphBody>
        This command has <b>{{ itemData.pendingCount }}</b> {{ pluralizePending }} pending.
        Cancelling this command will remove it from the command queue,
        and it will not run on any pending devices.
      </ParagraphBody>
      <ParagraphBody>
        To cancel the command, confirm the number of devices where the command
        is pending and will no longer run.
        <InputNumberInline
          :class="$style.inputTextConfirm"
          :focus="true"
          :rules="inputTextConfirmRules"
          :showValidationMessage="false"
          :value="inputTextConfirm"
          @input="value => handleInputTextConfirm(value)"
        />
      </ParagraphBody>
    </template>

    <template v-slot:footer>
      <ButtonGroup
        :isFullWidth="false"
      >
        <Button
          hasNoBackground=""
          text="Nevermind"
          @click="$emit('show', false)"
        />
        <Button
          hasOutline
          :isDisabled="confirmCancelButtonDisabled"
          text="Cancel Command"
          type="error"
          @click="$emit('continue')"
        />
      </ButtonGroup>
    </template>
  </ModalConfirmation>
</template>

<script>
import {
  Button,
  ButtonGroup,
  InputNumberInline,
  ModalConfirmation,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import pluralize from 'pluralize';

export default {
  name: 'CommandQueueCancelModal',
  components: {
    Button,
    ButtonGroup,
    InputNumberInline,
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    itemData: {
      required: true,
      type: Object,
    },
    showModal: {
      required: false,
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      inputTextConfirm: '',
    };
  },

  computed: {
    confirmCancelButtonDisabled() {
      return this.itemData.pendingCount !== parseInt(this.inputTextConfirm, 10);
    },

    inputTextConfirmRules() {
      return `required|numeric|is:${this.itemData.pendingCount}`;
    },

    pluralizePending() {
      return pluralize('device', this.itemData.pendingCount);
    },
  },

  methods: {
    handleInputTextConfirm(value) {
      this.inputTextConfirm = value;
    },
  },
};
</script>

<style module scoped>

.inputTextConfirm {
  margin-bottom: 1em;
  margin-top: 1em;
}

</style>
